export default function MilestonesProgressionChart({ milestoneData }) {
  const hasData = milestoneData && milestoneData.length > 0
  const maxCount = hasData ? Math.max(...milestoneData.map((m) => m.count), 1) : 1 

  return (
    <div className="bg-white p-2 rounded-lg shadow-sm">
      <h3 className="text-xl font-medium mb-2">Milestones progression</h3>
      <div className="relative h-70">
        {/* Y-axis label */}
        <div className="absolute left-0 top-0 h-64 flex flex-col justify-center">
          <div className="transform -rotate-90 translate-y-0 text-sm text-gray-500 whitespace-nowrap ml-[-20px]">
            N° of patients
          </div>
        </div>

        {/* Main chart container */}
        <div className="ml-10 h-full flex flex-col">
          {/* Chart bars area */}
          <div className="h-64 flex items-end">
            {hasData ? (
              milestoneData.map((milestone, index) => (
                <div key={index} className="flex flex-col items-center flex-1">
                  <div className="flex flex-col items-center justify-end w-full h-full">
                    <div
                      className="w-4/5 bg-blue-200 rounded-t-3xl flex items-center justify-center"
                      style={{
                        height: `${(milestone.count / maxCount) * 200}px`,
                      }}
                    >
                      <span className="font-medium py-2">{milestone.count}</span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex justify-center items-center w-full h-full text-gray-500">
                No milestone progression data available.
              </div>
            )}
          </div>

          {/* Baseline (border-b) */}
          <div className="w-full border-b border-gray-300"></div>

          {/* Milestone labels below baseline */}
          <div className="w-full flex mt-2">
            {hasData
              ? milestoneData.map((milestone, index) => (
                  <div key={index} className="flex-1 text-center">
                    <div className="text-sm">
                      Milestone
                      <br />
                      {milestone.number}
                    </div>
                  </div>
                ))
              : 
                Array.from({ length: 6 }).map((_, index) => (
                  <div key={index} className="flex-1 text-center">
                    <div className="text-sm">
                      Milestone
                      <br />
                      {index + 1}
                    </div>
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>
  )
}